import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { PRODUCT_DETAILS_POST, IMAGE_ADDRESS } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest';
import { handleChangeDataPageProductDetails } from '../../../../redux/actions/pages/product/productDetails';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useCartHandlers } from '../../../../utils/cartHandler';

import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import {Navigation, Pagination, EffectFade, Autoplay, Scrollbar, A11y} from 'swiper/modules';
import IncredibleSVG from '../../../../styles/images/svg/IncredibleOffer.svg';
import StarYellow from '../../../../styles/images/png/star-yellow.webp';
import ExpressDelivery from '../../../../styles/images/svg/infosection/express-delivery.svg';
import CashOnDelivery from '../../../../styles/images/svg/infosection/cash-on-delivery.svg';
import DaysReturn from '../../../../styles/images/svg/infosection/days-return.svg';
import OriginalProducts from '../../../../styles/images/svg/infosection/original-products.svg';
import Support from '../../../../styles/images/svg/infosection/support.svg';
import SpecialSell from '../../../../styles/images/svg/SpecialSell.svg';
import IncredibleEmoji from '../../../../styles/images/png/d38f4e94dd1ed5ba676fb166634dd8c4b6c572cb_1716833826.png';
import ProductImgWEBP from '../../../../styles/images/svg/digiplus/free-delivery.svg';
import ProductImgJpg from '../../../../styles/images/svg/digiplus/free-delivery.svg';

import React from "react";
import { Link } from 'react-router-dom';


const Product = () => {

	const dispatch = useDispatch();

	const { slug } = useParams();

	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { product, variants, selectedSku, selectedSeller, bestSeller, categories, attributes, attributesFull, isShowAllAttributes, similarGoods, descriptionExpanded, productComments } = useSelector(state => state.productDetails);
	const { carts } = useSelector(state => state.shoppingCart);
	const { showNav } = useSelector(state => state.headerDesktop);


	const selectedVariant = variants && variants.find(v => v.sku === selectedSku);
	const selectedSellerData = selectedVariant?.sellers.find(s => s.id === selectedSeller);
	const isInCart = carts && carts.find(cart => cart.sku === selectedVariant?.sku && cart.seller.id === selectedSellerData?.id);
	
	

	const handleChangeSku = (newSku) => {
		const newVariant = variants.find(v => v.sku === newSku);
	  	if (!newVariant) return;

	  	// آیا selectedSeller قبلی در این وریانت وجود دارد؟
	  	const matchedSeller = newVariant.sellers.find(s => s.id === selectedSeller);

	  	// اگر وجود دارد، همان را نگه داریم؛ اگر نه، اولین فروشنده را انتخاب کنیم
	  	const newSelectedSeller = matchedSeller ? matchedSeller.id : newVariant.sellers[0]?.id;

	  	// پیدا کردن فروشنده‌ای با کمترین قیمت
  		const minPrice = Math.min(...newVariant.sellers.map(s => parseInt(s.price)));

  		// پیدا کردن تمام فروشنده‌هایی که این قیمت رو دارن
  		const sellersWithMinPrice = newVariant.sellers.filter(s => parseInt(s.price) === minPrice);

  		// اگر فروشنده‌ی انتخاب‌شده فعلی در بین فروشنده‌هایی با کمترین قیمت بود، همون رو برگردون
  		const bestSeller = sellersWithMinPrice.find(s => s.id === newSelectedSeller)
    		|| sellersWithMinPrice[0]; // در غیر اینصورت اولینش


	  	// آپدیت وضعیت
	  	dispatch(handleChangeDataPageProductDetails('selectedSku', newSku));
	  	dispatch(handleChangeDataPageProductDetails('selectedSeller', newSelectedSeller));
	  	dispatch(handleChangeDataPageProductDetails('bestSeller', bestSeller));
	};


	useEffect(() => {
		callApiGetProductDetails();
	}, [Product, slug]);

	const callApiGetProductDetails = () => {
		if(! isBackdropLoading)
			apiRequest({
			    dispatch,
			    endpoint: (PRODUCT_DETAILS_POST),
			    data: {
			    	product: slug,
			    },
			    method: 'post',
			    onSuccess: (res) => {
			    	dispatch(handleChangeDataPageProductDetails('product', res.product));
			    	dispatch(handleChangeDataPageProductDetails('variants', res.variants));
			    	dispatch(handleChangeDataPageProductDetails('selectedSku', res.selectedSku));
			    	dispatch(handleChangeDataPageProductDetails('selectedSeller', res.selectedSeller));
			    	dispatch(handleChangeDataPageProductDetails('categories', res.categories));
			    	dispatch(handleChangeDataPageProductDetails('attributes', res.attributes));
			    	dispatch(handleChangeDataPageProductDetails('attributesFull', res.attributesFull));
			    	dispatch(handleChangeDataPageProductDetails('similarGoods', res.simillarProducts));
			    	dispatch(handleChangeDataPageProductDetails('productComments', res.productComments));

			    	{/**** dar surati k niyaz bashe "selectedSku" va "selectedSeller" az api hazf beshan, in block mitune samte server in 2 moteghayer ro set kone
			    	let bestVariant = null;
					let bestSeller = null;
					let minPrice = Infinity;

					res.variants.forEach(variant => {
					  	variant.sellers.forEach(seller => {
						    const price = parseInt(seller.price);
						    if (price < minPrice) {
						      	minPrice = price;
						      	bestVariant = variant;
						      	bestSeller = seller;
						    }
					  	});
					});
					// مقادیر پیش‌فرض برای وضعیت‌ها
					const defaultSelectedSku = bestVariant?.sku || null;
					const defaultSelectedSeller = bestSeller?.id || null;

					dispatch(handleChangeDataPageProductDetails('selectedSku', defaultSelectedSku));
				  	dispatch(handleChangeDataPageProductDetails('selectedSeller', defaultSelectedSeller));
				  	dispatch(handleChangeDataPageProductDetails('bestSeller', defaultSelectedSeller));

				  	ta inja *****/}
			    },
		  	});
	};

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};



	const commentRef = useRef(null);
	const goToComments = () => {
		setTimeout(() => {
	      	if (commentRef.current) {
	        	commentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
	      	}
	    }, 100);
	};


	const specRef = useRef(null);
	const attributeRef = useRef(null);
	const goToAttributes = () => {
		setTimeout(() => {
	      	if (attributeRef.current) {
	        	attributeRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
	      	}
	    }, 100);
	};
	const showAllAttributes = () => {
		dispatch(handleChangeDataPageProductDetails('isShowAllAttributes', true));

		setTimeout(() => {
	      	if (specRef.current) {
	        	specRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
	      	}
	    }, 100);
	};
	const hideAllAttributes = () => {
		dispatch(handleChangeDataPageProductDetails('isShowAllAttributes', false));
	}; 


	const toggleDescriptionExpanded = () => dispatch(handleChangeDataPageProductDetails('descriptionExpanded', !descriptionExpanded));
	const isLong = product.description !== null && product.description.length > 480;
  	const displayedDescriptionText = descriptionExpanded || !isLong ? product.description : product.description.substring(0, 480) + '...';

  	const { handleAddToCart, handleMinusBtn } = useCartHandlers(selectedVariant, product, slug);






  	// State برای ذخیره زمان باقی‌مانده
  	const [time, setTime] = useState(
	  	(selectedSellerData?.inCampaign || selectedSellerData?.inFlashSale)
	    ? {
	        hours: selectedSellerData?.remainingTime?.hours || 0,
	        minutes: selectedSellerData?.remainingTime?.minutes || 0,
	        seconds: selectedSellerData?.remainingTime?.seconds || 0,
	      }
	    : { hours: 0, minutes: 0, seconds: 0 }
	);


  	// تابع برای کاهش زمان
  	const tick = () => {
	    setTime((prevTime) => {
	      	let { hours, minutes, seconds } = prevTime;

	      	if (seconds > 0) {
	        	seconds -= 1;
	      	} else if (minutes > 0) {
	        	seconds = 59;
	        	minutes -= 1;
	      	} else if (hours > 0) {
		        seconds = 59;
		        minutes = 59;
		        hours -= 1;
	      	} else {
		        // وقتی زمان به صفر رسید، تایمر متوقف می‌شود
		        return { hours: 0, minutes: 0, seconds: 0 };
	      	}

	      	return { hours, minutes, seconds };
	    });
  	};

  	// تنظیم تایمر با useEffect
  	useEffect(() => {
	    // اگر محصول در کمپین نیست، زمان را صفر کن
	    if (!selectedSellerData?.inCampaign && !selectedSellerData?.inFlashSale) {
	      	setTime({ hours: 0, minutes: 0, seconds: 0 });
	      	return;
	    }

	    // تنظیم زمان اولیه بر اساس selectedSellerData
	    setTime({
	      	hours: selectedSellerData.remainingTime.hours,
	      	minutes: selectedSellerData.remainingTime.minutes,
	      	seconds: selectedSellerData.remainingTime.seconds,
	    });

	    // ایجاد تایمر
	    const timer = setInterval(tick, 1000);

	    // پاکسازی تایمر هنگام تغییر فروشنده/رنگ یا unmount
	    return () => clearInterval(timer);
  	}, [selectedSeller]);

  // 	// اگر محصول در کمپین نیست یا زمان صفر است، چیزی نمایش نده
  // 	if (!selectedSellerData?.inCampaign || (time.hours === 0 && time.minutes === 0 && time.seconds === 0)) {
		// return null;
  // 	}



    return (
    	
    	<div className="grow bg-neutral-000 flex flex-col w-full items-center shrink-0" style={{paddingTop: '188px', paddingLeft: '0px', paddingBottom: '0px'}}>
			<div id="base_layout_desktop_static_header" className="w-full">
			</div>
			<div id="base_layout_desktop_sticky_header" className="sticky bg-neutral-000 z-3 w-full styles_BaseLayoutDesktop__stickyHeader__LYwWR">
			</div>
			<div className="grow bg-neutral-000 flex flex-col w-full items-center styles_BaseLayoutDesktop__content__hfHD1 container-4xl-w">
				<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden">
				</div>
				<div className="lg:px-5">
					<div className="items-center flex flex-wrap lg:mb-5">
						<nav className="py-2 px-5 lg:px-0 grow min-w-0">
							<div>
								<Swiper
									className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode swiper-container-rtl"
									modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
		                            slidesPerView="auto"
		                            pagination={{clickable: true}}
		                            loop={false}
		                            navigation
		                            style={{ width: "100%" }} >
									<SwiperSlide style={{width: 'auto', height: 'auto'}}>
										<a className="text-neutral-500 text-body-2 shrink-0" data-cro-id="pdp-breadcrumb-up" href="/">کوچی
											<span className="mx-3">/
											</span>
										</a>
									</SwiperSlide>
									{
										categories && categories.map((cat, index) => (
											<SwiperSlide data={index} style={{width: 'auto', height: 'auto'}}>
												<Link className="text-neutral-500 text-body-2 shrink-0" data-cro-id="pdp-breadcrumb-up" to={`/category/${cat.url}`} >{cat.title}
													<span className="mx-3">{categories[index + 1] !== undefined ? '/' : '' }
													</span>
												</Link>
											</SwiperSlide>
										))
									}
								</Swiper>
							</div>
						</nav>
						<div className="hidden lg:flex items-center mr-auto py-2">
							<a className="text-body-2 text-neutral-400 flex items-center" data-cro-id="pdp-seller-cta" target="_blank" rel="noreferrer" href="/landings/seller-introduction/">فروش در کوچی
								<div className="flex mr-2">
									<svg style={{width: '18px', height: '18px', fill: 'var(--color-neutral-400)'}}>
										<use xlinkHref="#seller"></use>
									</svg>
								</div>
							</a>
						</div>
					</div>
					<div className="flex flex-col lg:flex-row overflow-hidden styles_PdpProductContent__sectionBorder--mobile__J7liJ">
						<div className="lg:ml-4 shrink-0 flex flex-col-reverse lg:flex-col styles_InfoSection__rightSection__PiYpa">
							






							{ selectedSellerData && selectedSellerData.inCampaign &&
							<div className="flex gap-3 items-center justify-between text-h5 px-5 py-2 py-2 lg:mb-5" style={{backgroundColor: 'rgba(230, 18, 61, 0.08)'}}>
								<div className="flex items-center justify-center">
									<div className="ml-2 flex items-center justify-center" style={{width: '139px', height: '16px', lineHeight: '0'}}>
										<img className="w-full inline-block" src={IncredibleSVG} width="139" height="16" alt="" title="" style={{objectFit: 'contain'}} />
									</div>
								</div>
								<div className="flex items-center justify-end grow">
									
									<span className="w-[1px] h-[10px] rounded mx-2" style={{backgroundColor: 'rgba(var(--color-neutral-500-rgb), 0.2)'}}>
									</span>
									<div className="flex items-center justify-center gap-1" style={{color: 'rgb(230, 18, 61)'}}>
										<span className="text-body2-strong lg:!leading-[30px] !leading-[22px] text-left lg:w-[75px] w-[65px]">{toPersianDigits(time.seconds)} : {toPersianDigits(time.minutes)} : {toPersianDigits(time.hours)}
										</span>
										<div className="flex">
											<div className="cube-font-icon" data-icon-name="cube-badge-end-soon" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'rgb(230, 18, 61)'}}>
											</div>
										</div>
									</div>
								</div>
							</div>
							}


							{ selectedSellerData && selectedSellerData.inFlashSale &&
							<div className="flex gap-3 items-center justify-between text-h5 px-5 py-2 py-2 lg:mb-5" style={{backgroundColor: 'rgba(230, 18, 61, 0.08)'}}>
								<div className="flex items-center justify-center">
									<div className="ml-2 flex items-center justify-center" style={{width: '139px', height: '16px', lineHeight: '0'}}>
										{/*<img className="w-full inline-block" src={IncredibleSVG} width="139" height="16" alt="" title="" style={{objectFit: 'contain'}} />*/}
										<span style={{color: '#E6123D', fontSize: '25px'}}>
											حـــــــــــــــراج
										</span>
									</div>
								</div>
								<div className="flex items-center justify-end grow">
									
									<span className="w-[1px] h-[10px] rounded mx-2" style={{backgroundColor: 'rgba(var(--color-neutral-500-rgb), 0.2)'}}>
									</span>
									<div className="flex items-center justify-center gap-1" style={{color: 'rgb(230, 18, 61)'}}>
										<span className="text-body2-strong lg:!leading-[30px] !leading-[22px] text-left lg:w-[75px] w-[65px]">{toPersianDigits(time.seconds)} : {toPersianDigits(time.minutes)} : {toPersianDigits(time.hours)}
										</span>
										<div className="flex">
											<div className="cube-font-icon" data-icon-name="cube-badge-end-soon" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'rgb(230, 18, 61)'}}>
											</div>
										</div>
									</div>
								</div>
							</div>
							}









							<div className="flex flex-col items-center lg:max-w-92 xl:max-w-145 lg:block" data-main-image-src="https://dkstatics-public.digikala.com/digikala-products/c0e38b30477ac8abfb52a38e01e5aa7ff06a5bdc_1740747481.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/quality,q_90">
								<div className="flex relative">
									<div className="flex lg:flex-col lg:gap-y-4 text-neutral-700 self-end lg:self-start lg:text-neutral-900">
										<div className="z-1 whitespace-nowrap ml-6 lg:ml-4" data-cro-id="pdp-favorite">
											<div>
												<div className="flex cursor-pointer cursor-pointer">
													<svg style={{width: '24px', height: '24px'}}>
														<use xlinkHref="#favoriteOff"></use>
													</svg>
												</div>
											</div>
											<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_Tooltip__tooltip__arrow--left__JOmNA styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="left" style={{position: 'absolute', inset: '0px 0px auto auto', transform: 'translate(-44px, 140px)'}}>اضافه به علاقه‌مندی
												<div>
												</div>
											</div>
										</div>
										<div className="z-1 whitespace-nowrap lg:ml-4" data-cro-id="pdp-share">
											<div>
												<div className="flex cursor-pointer cursor-pointer ml-5 lg:ml-0">
													<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
														<use xlinkHref="#share"></use>
													</svg>
												</div>
											</div>
											<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_Tooltip__tooltip__arrow--left__JOmNA styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="left" style={{position: 'absolute', inset: '0px 0px auto auto', transform: 'translate(-44px, 180px)'}}>به اشتراک‌گذاری کالا
												<div>
												</div>
											</div>
										</div>
										<div className="z-1 whitespace-nowrap lg:ml-4" data-cro-id="pdp-amazing-notif">
											<div>
												<div className="flex cursor-pointer cursor-pointer ml-5 lg:ml-0">
													<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
														<use xlinkHref="#notificationActiveOutline"></use>
													</svg>
												</div>
											</div>
											<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_Tooltip__tooltip__arrow--left__JOmNA styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="left" style={{position: 'absolute', inset: '0px 0px auto auto', transform: 'translate(-44px, 220px)'}}>اطلاع‌رسانی شگفت‌انگیز
												<div>
												</div>
											</div>
										</div>
										<div className="z-1 whitespace-nowrap lg:ml-4" data-cro-id="pdp-price-chart">
											<div>
												<div className="flex cursor-pointer cursor-pointer ml-5 lg:ml-0">
													<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
														<use xlinkHref="#priceChart"></use>
													</svg>
												</div>
											</div>
											<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_Tooltip__tooltip__arrow--left__JOmNA styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="left" style={{position: 'absolute', inset: '0px 0px auto auto', transform: 'translate(-44px, 260px)'}}>نمودار قیمت
												<div>
												</div>
											</div>
										</div>
										<a className="styles_Link__RMyqc" href="/compare/dkp-18478157/">
											<div className="z-1 whitespace-nowrap lg:ml-4" data-cro-id="pdp-compare">
												<div>
													<div className="flex cursor-pointer ml-5 lg:ml-0">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#compare"></use>
														</svg>
													</div>
												</div>
												<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_Tooltip__tooltip__arrow--left__JOmNA styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="left" style={{position: 'absolute', inset: '0px 0px auto auto', transform: 'translate(-44px, 300px)'}}>مقایسه کالا
													<div>
													</div>
												</div>
											</div>
										</a>
										<div className="z-1 whitespace-nowrap lg:ml-4" data-cro-id="pdp-wishlist">
											<div>
												<div className="flex cursor-pointer cursor-pointer ml-5 lg:ml-0">
													<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
														<use xlinkHref="#list"></use>
													</svg>
												</div>
											</div>
											<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_Tooltip__tooltip__arrow--left__JOmNA styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="true" data-popper-escaped="true" data-popper-placement="left" style={{position: 'absolute', inset: '0px 0px auto auto', transform: 'translate(-44px, 328px)'}}>افزودن به لیست
												<div>
												</div>
											</div>
										</div>
									</div>
									<div className="relative flex items-center">
										<div className="cursor-pointer" style={{lineHeight: '0'}}>
											<LazyLoadImage src={IMAGE_ADDRESS + product.image} alt={`خرید و قیمت  ${product.title}`} title={product.title} style={{objectFit: 'contain'}} className="w-full rounded-large overflow-hidden inline-block" />
										</div>
									</div>
									<div className="absolute w-full bottom-0 left-0">
										<div className="w-full">
											<div style={{lineHeight: '0'}}>
												<img className="w-full inline-block" alt="" title="" style={{objectFit: 'contain'}} />
											</div>
										</div>
									</div>
								</div>
								<div className="flex items-center mt-5 mb-3" width="501.109375" height="82">
									{
										product.images.map((image, index) => {
											if(index < 4)
												return (
													<div className="cursor-pointer rounded border-complete-200 p-1 ml-2" data-cro-id="pdp-album-open">
														<div style={{width: '72px', height: '72px', lineHeight: '0'}}>
															<LazyLoadImage src={IMAGE_ADDRESS + image} className="w-full inline-block" width={72} height={72} alt={`خرید و قیمت ${product.title}`} style={{objectFit: 'contain'}} />
														</div>
													</div>
												);
											else if( index == 4)
												return (
													<div className="flex items-center justify-center border-complete-200 rounded cursor-pointer p-1">
														<div className="styles_GalleryDesktop__blur__Tu0Ok" style={{width: '72px', height: '72px', lineHeight: '0'}}>
															<LazyLoadImage src={IMAGE_ADDRESS + image} className="w-full inline-block" width={72} height={72} alt={`خرید و قیمت ${product.title}`} style={{objectFit: 'contain'}} />
														</div>
														<div className="flex absolute">
															<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																<use xlinkHref="#moreHoriz"></use>
															</svg>
														</div>
													</div>
												);
											else
												return (
													''
												);
										})
										
									}
									
								</div>
							</div>
							{/*}
							<div className="hidden lg:flex items-center">
								<span data-cro-id="pdp-feedback">
									<div className="rounded cursor-pointer ml-9">
										<div className="flex">
											<div className="flex mt-1">
												<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-neutral-hint)'}}>
													<use xlinkHref="#infoOutline"></use>
												</svg>
											</div>
											<span className="mr-2 text-body-2 text-neutral-500">گزارش مشخصات کالا یا موارد قانونی
											</span>
										</div>
									</div>
								</span>
								<span className="text-caption text-neutral-400">  {slug}
								</span>
							</div>*/}
						</div>
						<div className="grow min-w-0">
							<div className="flex items-center w-full px-5 lg:px-0">
								<div className="">
									<div className="flex items-center">
										<nav className="flex items-center">
											{
												categories && categories.map((cat, index) => (
													<Link className="styles_Link__RMyqc" data-cro-id="pdp-breadcrumb-down" to={`/category/${cat.url}`}>
														{ index === 0 ?
															<span className="text-secondary-500 text-body1-strong">{cat.title}
															</span>
														:
															<div className="flex items-center">
																<p className="text-neutral-300 mx-2"> / 
																</p>
																<p className="text-secondary-500 text-body1-strong">{cat.title}
																</p>
															</div>
														}
													</Link>
												))
											}
										</nav>
									</div>
									<h1 className="text-h4 text-neutral-900 mb-2 pointer-events-none" data-testid="pdp-title">{product.title}
									</h1>
								</div>
							</div>
							<div className="styles_InfoSection__leftSection__0vNpX">
								<div className="min-w-0 styles_InfoSection__wrapper__e2TLb styles_InfoSection__variantInfo__PVSw4">
									<div className="items-center flex mx-5 lg:mx-0">
										<span className="text-neutral-300 ml-2 text-body-2">
										</span>
										<div className="bg-neutral-200 grow styles_VariantInfo__enTitleLine__HNqBN">
										</div>
									</div>
									<div className="flex items-center flex-wrap mt-2 ml-0 lg:mx-0">
										<div className="flex items-center">
											<div style={{width: '16px', height: '16px', lineHeight: '0'}}>
												<picture>
													<source type="image/webp" srcset={StarYellow} />
													<source type="image/jpeg" srcset={StarYellow} />
													<img className="w-full inline-block" src={StarYellow} width="16" height="16" alt="امتیاز" title="" style={{objectFit: 'contain'}} />
												</picture>
											</div>
											<p className="mr-1 text-body-2">{toPersianDigits(product.rate)}
											</p>
											<p className="mr-1 text-caption text-neutral-300 whitespace-nowrap">(امتیاز {toPersianDigits(product.totalPoint)} خریدار)
											</p>
										</div>
										<div className="lg:w-unset w-full lg:overflow-hidden overflow-x-auto hide-scrollbar px-5 lg:px-1.5">
											<div className="flex items-center gap-1.5 w-full">
												<div className="flex items-center">
													<span onClick={goToComments} className="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-body-2 cursor-pointer py-1" data-cro-id="pdp-comments-abovefold">
														<span>
															<span className="bg-gradient-silver flex item-center text-body2-strong pr-2 pl-1 text-icon-high-emphasis rounded-lg whitespace-nowrap">{toPersianDigits(product.commentCount)} دیدگاه
																<div className="flex items-center">
																	<div className="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
																	</div>
																</div>
															</span>
														</span>
													</span>
												</div>
												{/*<span className="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-body-2 cursor-pointer py-1 pl-5" data-cro-id="pdp-questions-abovefold">
													<span>
														<span className="bg-gradient-silver flex item-center text-body2-strong pr-2 pl-1 text-icon-high-emphasis rounded-lg whitespace-nowrap">{toPersianDigits(product.questionCount)} پرسش
															<div className="flex items-center">
																<div className="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
																</div>
															</div>
														</span>
													</span>
												</span>*/}
											</div>
										</div>
									</div>
									{ variants &&
									<div className="lg:border-none lg:mt-0 border-complete-t mt-3">
										<div className="break-words py-3 mx-5 lg:mx-0">
											<div className="flex items-center grow">
												<p className="grow text-h5 text-neutral-900">
													<span className="relative">
														{ selectedVariant && selectedVariant.attributeTile &&
															`${selectedVariant.attributeTile}: ${selectedVariant.optionTitle}`
														}
													</span>
												</p>
												<p className="mr-auto lg:hidden text-neutral-500 text-button-2 ">{toPersianDigits(variants.length)} رنگ
												</p>
											</div>
										</div>
										<div className="flex lg:flex-wrap overflow-x-auto px-5 lg:px-0">
											{
												variants.map((variant, index) => (
													<div onClick={() => handleChangeSku(variant.sku)} className={`bg-neutral-000 flex items-center justify-center cursor-pointer ml-2 px-2 lg:px-0 styles_InfoSectionVariationColor__pX_3M ${variant.sku === selectedSku ? 'styles_InfoSectionVariationColor__selected__MqDpU' : ''}`}>
														<div className="whitespace-nowrap">
															<div>
																<div className="flex items-center">
																	<div className="rounded-circle flex items-center justify-center styles_InfoSectionVariationColorContent__iconWrapper__WEy3t">
																		<div className="rounded-circle mx-auto border-complete lg:border-none flex items-center justify-center styles_InfoSectionVariationColorContent__main__OUcdN" style={{background: `#${variant.optionColor}`}}>
																		{ variant.sku === selectedSku &&
																			<div className="flex">
																				<svg style={{width: '24px', height: '24px', fill: `${variant.optionColor === "000000" ? 'var(--color-icon-white)' : 'var(--color-icon-black)'}`}}>
																					<use xlinkHref="#done"></use>
																				</svg>
																			</div>
																		}
																		</div>
																	</div>
																</div>
															</div>
															<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_Tooltip__tooltip__arrow--bottom__rZ4eR styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom" style={{position: 'absolute', inset: '0px auto auto 0px', transform: 'translate(875px, 277px)'}}>{variant.optionTitle}
																<div>
																</div>
															</div>
														</div>
													</div>
												))
											}
										</div>
									</div>
									}
								</div>
								
								<div class="styles_InfoSection__spec__X1ocW">
									<div class="w-full">
										<div class="break-words py-3">
											<div class="flex items-center grow">
												<p class="grow text-h5 text-neutral-900">
													<span class="relative">ویژگی‌ها</span>
												</p>
											</div>
										</div>
										<div class="overflow-auto hide-scrollbar">
											<ul class="!pb-0 flex gap-1 w-max lg:w-auto lg:gap-2 mt-2 lg:grid lg:grid-cols-3 lg:overflow-hidden">
												{
													attributes && attributes.map((attribute, index) => (
														<li class="flex flex-col items-start justify-start bg-neutral-100 p-2 rounded-md">
															<div class="flex flex-col gap-2 max-w-[150px]">
																<div>
																	<p class="text-neutral-500 text-body-2 !leading-none lg:!leading-9 lg:break-all lg:overflow-hidden ellipsis-1">{attribute.attribute}
																	</p>
																	<p class="text-body2-strong !leading-none lg:!leading-9 text-neutral-700 break-all lg:overflow-hidden ellipsis-1">{attribute.value}
																	</p>
																</div>
																<div class="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_Tooltip__tooltip__arrow--bottom-start__rvwG1 styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="true" data-popper-escaped="true" data-popper-placement="top-start" style={{position: 'absolute', inset: 'auto auto 0px 0px', transform: 'translate(705px, 411px)'}}>{attribute.value}
																	<div>
																	</div>
																</div>
															</div>
														</li>
													))
												}
											</ul>
										</div>
										<div class="flex justify-center items-center gap-4 mt-4">
											<hr class="border-none grow styles_InfoSectionSpec__hRPuo" />
											<button onClick={goToAttributes} class="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--outlined__saFC3 styles_btn--black__xj6Mt rounded-medium styles_InfoSectionSpec__hRPuo" >
												<div class="flex items-center justify-center relative grow">مشاهده همه ویژگی‌ها
													<div class="flex mr-2">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-black)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
												</div>
											</button>
											<hr class="border-none grow styles_InfoSectionSpec__hRPuo" />
										</div>
									</div>
									<div class="rounded my-3 mx-5 lg:mx-0">
										
									</div>
								</div>
								
								<div className="flex flex-col lg:mr-3 lg:mb-3 lg:gap-y-2 styles_InfoSection__buyBoxContainer__3nOwP">
								{ !selectedSellerData ?
									<div class="relative flex flex-col items-center" data-testid="buy-box">
										<div class="p-4 lg:text-center bg-[#f5f5f5] border-complete rounded-[6px]">
											<p class="text-neutral-700 text-right text-body-1">این کالا فعلا موجود نیست اما می‌توانید زنگوله را بزنید تا به محض موجود شدن، به شما خبر دهیم.</p>
										</div>
									</div>
									:
									<div className="styles_Marketable__3IHFu lg:rounded-medium lg:border-complete-200 bg-neutral-000 styles_InfoSection__buybox__tknJ3" data-testid="buy-box">
										<div className="break-words pt-4 pb-2 px-5 w-full flex items-center justify-between user-select-none">
											<h3 className="grow text-h5 text-neutral-900">فروشنده
											</h3>
											<span data-cro-id="pdp-other-seller" className="text-body-2 text-secondary-500 cursor-pointer">
											</span>
										</div>
										<div className="bg-neutral-000 overflow-y-auto rounded-small styles_Popper__OOG0C shadow-modal border-complete-200 z-3 styles_Popper--animated-inactive__oIC9r" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="right-end" style={{position: 'absolute', inset: 'auto auto 0px 0px', transform: 'translate(364px, -4px)', display: 'none'}}>
											<div className="py-4 px-5 bg-neutral-000 relative  lg:min-w-80">
												<div className="flex justify-between items-center w-full text-h5">{selectedSellerData && selectedSellerData.title}
												</div>
												<p className="text-body-2 text-neutral-500">عضو از ۳ سال و ۶ ماه
												</p>
												<div className="text-center my-4">
													<p className="text-h1-extra" style={{color: 'var(--color-rating-0-2)'}}>۵۰%
													</p>
													<p className="text-body1-strong">رضایت خریداران از کیفیت کالاها
													</p>
													<p className="text-body-2 text-neutral-500">۱۴ نفر امتیاز داده‌اند
													</p>
												</div>
												<div className="w-full flex items-center justify-center rounded-large overflow-x-hidden mt-3">
													<div className="bg-rating-4-5 styles_SellerInfoDetails__successBar__55_ZG" style={{width: '14.29%'}}>
													</div>
													<div className="bg-rating-3-4 styles_SellerInfoDetails__successBar__55_ZG" style={{width: '21.43%'}}>
													</div>
													<div className="bg-rating-2-3 styles_SellerInfoDetails__successBar__55_ZG" style={{width: '7.14%'}}>
													</div>
													<div className="bg-rating-0-2 styles_SellerInfoDetails__successBar__55_ZG" style={{width: '14.29%'}}>
													</div>
													<div className="bg-hint-object-caution styles_SellerInfoDetails__successBar__55_ZG" style={{width: '42.86%'}}>
													</div>
												</div>
												<div className="flex justify-between items-center w-full text-caption mt-1 pb-5 border-complete-b text-neutral-500">
													<span>کاملا راضی
													</span>
													<span>کاملا ناراضی
													</span>
												</div>
												<div className="text-center my-2">
													<p className="text-h1-extra" style={{color: 'var(--color-rating-4-5)'}}>عالی
													</p>
													<p className="text-body1-strong">عملکرد کلی فروشنده
													</p>
												</div>
												<div className="flex content-center mt-2 justify-between">
													<div className="text-center">
														<p className="text-h5 text-neutral-500">۹۸.۹٪
														</p>
														<p className="text-neutral-500 text-caption">تامین به موقع
														</p>
													</div>
													<div className="text-center">
														<p className="text-h5 text-neutral-500">۹۹.۹٪
														</p>
														<p className="text-neutral-500 text-caption">تعهد ارسال
														</p>
													</div>
													<div className="text-center">
														<p className="text-h5 text-neutral-500">۹۹.۵٪
														</p>
														<p className="text-neutral-500 text-caption">بدون مرجوعی
														</p>
													</div>
												</div>
											</div>
										</div>
										<div>
											<a className="styles_Link__RMyqc" target="_blank" href="/seller/DSWK7/">
												<div className="w-full px-4 flex" data-cro-id="pdp-seller-info-cta">
													<div className="py-3 flex grow flex !pt-0 !pb-4">
														<div className="ml-4">
															<div className="relative">
																<div className="flex">
																	<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																		<use xlinkHref="#seller"></use>
																	</svg>
																</div>
															</div>
														</div>
														<div className="flex w-full">
															<div>
																<div className="flex items-center mb-2 lg:mb-1">
																	<span>
																		<p className="text-neutral-700 ml-2 text-subtitle">{selectedSellerData && selectedSellerData.title}
																		</p>
																	</span>
																</div>
																<div className="w-full flex items-center content-center text-body-2">
																	<div className="pl-2 flex items-center divider">
																		<p className="ml-1 text-body2-strong" style={{color: 'var(--color-rating-0-2)'}}>{selectedSellerData && toPersianDigits(selectedSellerData.productRatePercent)}%</p>
																		<p className="text-neutral-500 whitespace-nowrap">رضایت از کالا</p>
																	</div>
																	<div className="pr-2 flex items-center">
																		<p className="text-neutral-500 ml-1">عملکرد
																		</p>
																		<p className="whitespace-nowrap text-body2-strong" style={{color: 'var(--color-rating-4-5)'}}>{selectedSellerData && selectedSellerData.sellerPerformance}
																		</p>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</a>
										</div>
										<div className="relative w-full lg:px-4 lg:pb-2">
											<div className="border-complete-t-200 lg:pt-4">
												<div className="w-full  z-3 bg-neutral-000 shadow-fab-button lg:shadow-none styles_BuyBoxFooter__actionWrapper__Hl4e7">
													<div>
														{
															bestSeller && selectedSellerData && bestSeller.id !== selectedSellerData.id &&
															<div class="px-2 py-2 styles_Hint--warning__yXWrd rounded-md cursor-pointer mb-4">
																<div class="flex items-center">
																	<div class="flex">
																		<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-warning)'}}>
																			<use xlinkHref="#infoOutline"></use>
																		</svg>
																	</div>
																	<span class="mr-2 text-body-2 text-hint-text-caution"></span>
																	<div class="flex items-center justify-between w-full ">
																		<p class="text-caption-strong text-neutral-700">با قیمت {toPersianDigits(bestSeller.priceTxt)} تومان از فروشندگان دیگر</p>
																		<div class="flex">
																			<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
																				<use xlinkHref="#chevronLeft"></use>
																			</svg>
																		</div>
																	</div>
																</div>
															</div>
														}
														<div className="flex items-center">
															<div className="flex a-center">
																<div>
																	<div>
																		<div className="flex cursor-pointer">
																			<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
																				<use xlinkHref="#infoOutline"></use>
																			</svg>
																		</div>
																	</div>
																	<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_Tooltip__tooltip__arrow--bottom__rZ4eR styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="true" data-popper-escaped="true" data-popper-placement="top" style={{position: 'absolute', inset: 'auto auto 0px 0px', transform: 'translate(327px, 9px)'}}>این کالا توسط فروشنده آن، بازرگانی ایتالیا، قیمت‌گذاری شده‌ است.
																		<div>
																		</div>
																	</div>
																</div>
															</div>
															<div className="flex justify-start flex-col items-end mr-auto text-h3">
																{ selectedSellerData && selectedSellerData.discount > 0 ?
																<div className="flex items-center justify-end w-full gap-1">
																	<span className="line-through text-body-2 ml-1 text-neutral-300" data-testid="price-no-discount">{toPersianDigits(selectedSellerData.oldPriceTxt)}
																	</span>
																	<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error shrink-0 mr-1 mb-1">
																		<span className="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(selectedSellerData.discount)}٪
																		</span>
																	</div>
																</div> :''}
																<div className="flex flex-row items-center">
																	<span className="ml-1 text-neutral-800 text-h4-compact" data-testid="price-final">{selectedSellerData && toPersianDigits(selectedSellerData.priceTxt)}
																	</span>
																	<div className="flex">
																		<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
																			<use xlinkHref="#toman"></use>
																		</svg>
																	</div>
																</div>
															</div>
														</div>
														
														<div className="flex items-center lg:mt-4">
															{ isInCart === undefined ?
															<button onClick={() => handleAddToCart(selectedSellerData)} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--primary__y0GEv rounded-medium w-full" data-cro-id="pdp-add-to-cart" data-add-to-cart-variant-id="64672704" data-testid="add-to-cart">
																<div className="flex items-center justify-center relative grow">افزودن به سبد
																</div>
															</button>
															:
															<>
																<div class="flex items-center justify-between user-select-none px-2 rounded-medium shadow-fab-button item-quantity_ItemQuantity__box__5r4FJ grow">
																	<div onClick={() => handleAddToCart(selectedSellerData)} class={`flex cursor-pointer ${1 === 2 ? 'opacity-50 pointer-events-none p-0 lg:p-0' : ''}`}>
																		<svg data-testid="quantity-increase" data-cro-id="pdp-main-add-quantitiy" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																			<use xlinkHref="#addSimple"></use>
																		</svg>
																	</div>
																	<span class="flex flex-col items-center justify-between text-primary-500">
																		<span class={`relative flex items-center justify-center text-h5 ${1 === 2 ? 'item-quantity_ItemQuantity__boxCount__9ZT6i' : ''}`}>{toPersianDigits(isInCart.number)}
																		</span>
																		{/*<small class="text-caption text-neutral-300">حداکثر</small>*/}
																	</span>
																	<div onClick={() => handleMinusBtn(selectedSellerData)} class="flex cursor-pointer">
																		<svg data-testid="quantity-decrease" data-cro-id="pdp-main-delete-quantitiy" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																			<use xlinkHref="#{isInCart.number > 1 'removeSimple' : delete}"></use>
																			<use xlinkHref={`#${isInCart.number > 1 ? 'removeSimple' : 'delete'}`}></use>
																		</svg>
																	</div>
																</div>
																<div class="mr-2 lg:mr-4 hidden lg:block shrink-0">
																	<p class="text-neutral-700 text-body-1">در سبد شما
																	</p>
																	<div class="flex items-center">مشاهده
																		<Link class="text-secondary-500" data-cro-id="pdp-see-cart-main" to={`/checkout/cart`}>
																			<p class="mr-1 text-body-2">سبد خرید
																			</p>
																		</Link>
																	</div>
																</div>
															</>
															}
														</div>
													</div>
												</div>
											</div>
										</div>

										<div className="flex flex-col gap-y-1 mx-0 lg:mx-5 py-1 px-4 lg:px-0 text-body-2">
										</div>
									</div>
								}

								</div>
							</div>
						</div>
					</div>
					<div className="border-complete-t px-3 items-center justify-between pt-3 pb-7 flex lg:mt-3 styles_Footer__a0yS8">
						<div className="w-full flex gap-y-4 lg:gap-y-2 mx-auto justify-between">
							<Swiper
								className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode swiper-container-rtl"
								modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
	                            slidesPerView="5"
	                            pagination={{clickable: true}}
	                            loop={false}
	                            navigation
	                            style={{ width: "100%" }}
	                            spaceBetween={24} >

	                            <SwiperSlide style={{width: 'auto', height: 'auto'}}>
	                            	<a className="styles_Footer__item__kcYwG" data-cro-id="pdp-some-info" href="/faq/question/79/">
										<div className="flex flex-col lg:flex-row items-center justify-center px-1">
											<div className="lg:inline-block lg:ml-2 filter" style={{width: '42px', height: '42px', lineHeight: '0'}}>
												<img className="w-full inline-block" src={ExpressDelivery} width="42" height="42" alt="امکان تحویل اکسپرس" title="" style={{objectFit: 'contain'}} />
											</div>
											<p className="text-center text-caption-strong text-neutral-400">امکان تحویل اکسپرس
											</p>
										</div>
									</a>
	                            </SwiperSlide>
	                            <SwiperSlide style={{width: 'auto', height: 'auto'}}>
	                            	<a className="styles_Footer__item__kcYwG" data-cro-id="pdp-some-info" href="/faq/question/80/">
										<div className="flex flex-col lg:flex-row items-center justify-center px-1">
											<div className="lg:inline-block lg:ml-2 filter" style={{width: '42px', height: '42px', lineHeight: '0'}}>
												<img className="w-full inline-block" src={Support} width="42" height="42" alt="امکان تحویل اکسپرس" title="" style={{objectFit: 'contain'}} />
											</div>
											<p className="text-center text-caption-strong text-neutral-400">۲۴ ساعته، ۷ روز هفته
											</p>
										</div>
									</a>
	                            </SwiperSlide>
	                            <SwiperSlide style={{width: 'auto', height: 'auto'}}>
	                            	<a className="styles_Footer__item__kcYwG" data-cro-id="pdp-some-info" href="/faq/question/81/">
										<div className="flex flex-col lg:flex-row items-center justify-center px-1">
											<div className="lg:inline-block lg:ml-2 filter" style={{width: '42px', height: '42px', lineHeight: '0'}}>
												<img className="w-full inline-block" src={CashOnDelivery} width="42" height="42" alt="امکان تحویل اکسپرس" title="" style={{objectFit: 'contain'}} />
											</div>
											<p className="text-center text-caption-strong text-neutral-400">امکان پرداخت در محل
											</p>
										</div>
									</a>
	                            </SwiperSlide>
	                            <SwiperSlide style={{width: 'auto', height: 'auto'}}>
	                            	<a className="styles_Footer__item__kcYwG" data-cro-id="pdp-some-info" href="/faq/question/83/">
										<div className="flex flex-col lg:flex-row items-center justify-center px-1">
											<div className="lg:inline-block lg:ml-2 filter" style={{width: '42px', height: '42px', lineHeight: '0'}}>
												<img className="w-full inline-block" src={DaysReturn} width="42" height="42" alt="امکان تحویل اکسپرس" title="" style={{objectFit: 'contain'}} />
											</div>
											<p className="text-center text-caption-strong text-neutral-400">هفت روز ضمانت بازگشت کالا
											</p>
										</div>
									</a>
	                            </SwiperSlide>
	                            <SwiperSlide style={{width: 'auto', height: 'auto'}}>
	                            	<a className="styles_Footer__item__kcYwG" data-cro-id="pdp-some-info" href="/faq/question/82/">
										<div className="flex flex-col lg:flex-row items-center justify-center px-1">
											<div className="lg:inline-block lg:ml-2 filter" style={{width: '42px', height: '42px', lineHeight: '0'}}>
												<img className="w-full inline-block" src={OriginalProducts} width="42" height="42" alt="امکان تحویل اکسپرس" title="" style={{objectFit: 'contain'}} />
											</div>
											<p className="text-center text-caption-strong text-neutral-400">ضمانت اصل بودن کالا
											</p>
										</div>
									</a>
	                            </SwiperSlide>
	                            
							</Swiper>
						</div>
					</div>
					{
						selectedVariant && selectedVariant.sellers.length > 1 &&

						<div id="sellerSection">
							<div class="hidden lg:block lg:mt-4 px-5 lg:px-0 pb-5 styles_PdpProductContent__sectionBorder__39zAX">
								<div class="break-words py-3">
									<div class="flex items-center grow">
										<p class="grow text-h5 text-neutral-900">
											<span class="relative">فروشندگان این کالا
											</span>
										</p>
									</div>
									<div class="mt-2 styles_Title__line__KyW9l styles_Title__line--red__TP9mu">
									</div>
								</div>
								{
									selectedVariant.sellers.map((seller, index) => {
										const isThisSellerInCart = carts && carts.find(cart => cart.sku === selectedVariant?.sku && cart.seller.id === seller.id);
										return (
											<div key={index} class="rounded-medium styles_SellerListItemDesktop__sellerListItem__u9p3q p-4">
												<div class="flex justify-center lg:justify-between items-center">
													<div class="lg:grid grid-cols-3 items-center grow">
														{/*<div class="bg-neutral-000 overflow-y-auto rounded-small styles_Popper__OOG0C shadow-modal border-complete-200 z-3 styles_Popper--animated-inactive__oIC9r" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="left-end" style={{position: 'absolute', inset: 'auto 0px 0px auto', transform: 'translate(-398px, 1281px)'}}>
															<div class="py-4 px-5 bg-neutral-000 relative  lg:min-w-80" style={{display: 'none'}}>
																<div class="flex justify-between items-center w-full text-h5">{seller.title}
																</div>
																<p class="text-body-2 text-neutral-500">عضو از ۴ سال و ۱۰ ماه
																</p>
																<div class="text-center my-4">
																	<p class="text-h1-extra" style={{color: 'var(--color-rating-4-5)'}}>۹۶.۶%
																	</p>
																	<p class="text-body1-strong">رضایت خریداران از کیفیت کالاها
																	</p>
																	<p class="text-body-2 text-neutral-500">۶ نفر امتیاز داده‌اند
																	</p>
																</div>
																<div class="w-full flex items-center justify-center rounded-large overflow-x-hidden mt-3">
																	<div class="bg-rating-4-5 styles_SellerInfoDetails__successBar__55_ZG" style={{width: '83.33%'}}>
																	</div>
																	<div class="bg-rating-3-4 styles_SellerInfoDetails__successBar__55_ZG" style={{width: '16.67%'}}>
																	</div>
																	<div class="bg-rating-2-3 styles_SellerInfoDetails__successBar__55_ZG" style={{width: '0%'}}>
																	</div>
																	<div class="bg-rating-0-2 styles_SellerInfoDetails__successBar__55_ZG" style={{width: '0%'}}>
																	</div>
																	<div class="bg-hint-object-caution styles_SellerInfoDetails__successBar__55_ZG" style={{width: '0%'}}>
																	</div>
																</div>
																<div class="flex justify-between items-center w-full text-caption mt-1 pb-5 border-complete-b text-neutral-500">
																	<span>کاملا راضی
																	</span>
																	<span>کاملا ناراضی
																	</span>
																</div>
																<div class="text-center my-2">
																	<p class="text-h1-extra" style={{color: 'var(--color-rating-4-5)'}}>عالی
																	</p>
																	<p class="text-body1-strong">عملکرد کلی فروشنده
																	</p>
																</div>
																<div class="flex content-center mt-2 justify-between">
																	<div class="text-center">
																		<p class="text-h5 text-neutral-500">۱۰۰٪
																		</p>
																		<p class="text-neutral-500 text-caption">تامین به موقع
																		</p>
																	</div>
																	<div class="text-center">
																		<p class="text-h5 text-neutral-500">۱۰۰٪
																		</p>
																		<p class="text-neutral-500 text-caption">تعهد ارسال
																		</p>
																	</div>
																	<div class="text-center">
																		<p class="text-h5 text-neutral-500">۹۹.۹٪
																		</p>
																		<p class="text-neutral-500 text-caption">بدون مرجوعی
																		</p>
																	</div>
																</div>
															</div>
														</div>*/}
														<div class="relative flex items-center">
															<div class="relative">
																<div class="flex">
																	<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																		<use xlinkHref="#seller"></use>
																	</svg>
																</div>
																<div class="flex absolute bg-neutral-000 rounded-circle text-rating-4-5 styles_SellerShippingIcon__buBoxSellerIconBadge__z1FAk">
																	<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-rating-4-5)'}}>
																		<use xlinkHref="#verifiedUser"></use>
																	</svg>
																</div>
															</div>
															<div class="mr-4">
																<div class="flex items-center mb-2 lg:mb-1">
																	<a class="styles_Link__RMyqc" href="https://www.digikala.com/seller/CGDG9/">
																		<p class="text-neutral-700 ml-2 text-subtitle">{seller.title}
																		</p>
																	</a>
																	<div class="py-1 flex items-center justify-center styles_SellerBadge__badge__843gK styles_SellerBadge__badgeIsTrusted__7mdJT">
																		<div class="inline-flex items-center Badge_Badge__QIekq Badge_Badge--small__ElV6O px-2 text-caption-strong" style={{backgroundColor: 'var(--color-undefined)', color: 'var(--color-undefined)'}}>
																			<p class="inline-block  text-caption-strong text-caption-strong">
																			</p>
																		</div>
																	</div>
																</div>
																<div class="w-full flex items-center content-center text-body-2">
																	<div class="pl-2 flex items-center divider">
																		<p class="ml-1 text-body2-strong" style={{color: 'var(--color-rating-4-5)'}}>{toPersianDigits(seller.productRatePercent)}%
																		</p>
																		<p class="text-neutral-500 whitespace-nowrap">رضایت از کالا
																		</p>
																	</div>
																	<div class="pr-2 flex items-center">
																		<p class="text-neutral-500 ml-1">عملکرد
																		</p>
																		<p class="whitespace-nowrap text-body2-strong" style={{color: 'var(--color-rating-4-5)'}}>{seller.sellerPerformance}
																		</p>
																	</div>
																</div>
															</div>
														</div>
														
														{/*<div class="mr-6 flex items-center justify-center items-center">
															<div class="flex ml-2 text-neutral-700">
																<svg style={{width: '20px', height: '20px'}}>
																	<use xlinkHref="#guarantee"></use>
																</svg>
															</div>
															<p class="text-subtitle text-neutral-700">نام گارانتی
															</p>
														</div>*/}
													</div>
													<div class="flex items-center justify-end min-w-4/lg:12">
														<div class="ml-6">
															<div>
																<div class="flex items-center justify-start">
																	<div class="flex justify-start items-center gap-1">
																		{ seller.oldPrice ?
																		<span className="line-through text-body-2 ml-1 text-neutral-300">{toPersianDigits(seller.oldPriceTxt)}
																		</span>
																		:
																		<span class="text-h4 ml-1 text-neutral-800">{toPersianDigits(seller.priceTxt)}
																		</span>
																		}
																	</div>
																	<div class="flex items-center justify-between">
																		<div class="flex items-center">
																			{ seller.oldPrice &&
																				<span className="text-neutral-800 ml-0.5 text-h4">{toPersianDigits(seller.priceTxt)}
																				</span>
																			}
																			<div class="flex">
																				<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
																					<use xlinkHref="#toman"></use>
																				</svg>
																			</div>
																		</div>
																	</div>
																	{ seller.discount &&
																		<div class="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error shrink-0 mr-1">
																			<span class="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(seller.discount)}٪
																			</span>
																		</div>
																	}
																</div>
															</div>
														</div>
														<div class="shrink-0">
														{ isThisSellerInCart ?
															<div class="flex items-center justify-between user-select-none px-2 rounded-medium shadow-fab-button item-quantity_ItemQuantity__box__5r4FJ">
																<div onClick={() => handleAddToCart(seller)} class="flex cursor-pointer">
																	<svg data-testid="quantity-increase" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																		<use xlinkHref="#addSimple"></use>
																	</svg>
																</div>
																<span class="flex flex-col items-center justify-between text-primary-500">
																	<span class="relative flex items-center justify-center text-h5">{toPersianDigits(isThisSellerInCart.number)}
																	</span>
																</span>
																<div onClick={() => handleMinusBtn(seller)} class="flex cursor-pointer">
																	<svg data-testid="quantity-decrease" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																		<use xlinkHref={`#${isThisSellerInCart.number > 1 ? 'removeSimple' : 'delete'}`}></use>
																	</svg>
																</div>
															</div>
															:
															<button onClick={() => handleAddToCart(seller)} class="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--primary__y0GEv rounded-medium w-full" data-add-to-cart-variant-id="56639561" data-testid="add-to-cart">
																<div class="flex items-center justify-center relative grow">افزودن به سبد
																</div>
															</button>
														}
														</div>
													</div>
												</div>
											</div>
										);
											
									})
								}
							</div>
						</div>
					}
					{similarGoods && similarGoods.length > 0 &&
					<div className="lazyload-wrapper ">
						<div>
							<div className="flex flex-col relative overflow-hidden w-full pt-2 lg:border-complete-200 lg:rounded-medium lg:mt-4 pb-3 w-screen !lg:w-auto styles_PdpProductContent__sectionBorder__39zAX">
								<div className="break-words py-3 px-5 py-2 user-select-none">
									<div className="flex items-center grow">
										<h2 className="grow text-h5 text-neutral-900">
											<span className="relative">کالاهای مشابه
											</span>
										</h2>
									</div>
									<div className="mt-2 styles_Title__line__KyW9l styles_Title__line--red__TP9mu">
									</div>
								</div>
								<div>
									<Swiper
										className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode swiper-container-rtl"
										modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
					                    slidesPerView="auto"
					                    pagination={{clickable: true}}
					                    loop={false}
					                    navigation
					                    style={{ width: "100%" }}
					                    spaceBetween={24} >

					                    {
					                    	similarGoods.map((product, key) => {
					                    		return (
					                    			<SwiperSlide key={`similar-goods-${key}`} style={{width: 'auto', height: 'auto'}}>
					                    				<Link to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} className="block cursor-pointer relative bg-neutral-000 overflow-hidden grow py-3 px-4 lg:px-2 h-full border-complete-l" data-cro-id="related-products"   style={{width: '192px', maxWidth: '192px', minWidth: '192px'}} >
															<div data-testid="product-card" className="h-full">
																<article className="overflow-hidden flex flex-col items-stretch justify-start h-full">
																	<div className="flex items-center justify-start mb-1">
																		<div className="ml-1" style={{width: '64px', height: '14px', lineHeight: '0'}}>
																			{product.discount !== '' ?
																			<LazyLoadImage className="w-full inline-block" src={SpecialSell} width="64" height="14" alt="" title="" style={{objectFit: 'contain'}} />
																			:''}
																		</div>
																		<div className="text-body2-extra grow">
																			<br />
																		</div>
																	</div>
																	<div className="flex grow relative flex-col">
																		<div className="">
																			<div className="flex items-stretch flex-col relative mb-1">
																				<div className="flex items-start mx-auto">
																					<div>
																						<div className="flex items-center justify-start gap-1 flex-wrap absolute top-0 right-0 z-1 style_ProductImage__miniBadges__uxcGX">
																							<br />
																							<br />
																						</div>
																						<div style={{width: '150px', height: '150px', lineHeight: '0'}}>
																							<picture>
																								<source type="image/webp" srcset={IMAGE_ADDRESS + product.image} />
																								<source type="image/jpeg" srcset={IMAGE_ADDRESS + product.image} />
																								<LazyLoadImage className="w-full rounded-medium inline-block" src={IMAGE_ADDRESS + product.image} width="150" height="150" alt={product.title} title="" style={{objectFit: 'contain'}} />
																							</picture>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																		<div className="grow flex flex-col items-stretch justify-start">
																			<div><h3 className="ellipsis-2 text-body2-strong text-neutral-700 styles_VerticalProductCard__productTitle__6zjjN">{product.title}</h3>
																			</div>
																			<div className="mb-1 flex items-center justify-between">
																				<div className="flex items-center" data-ab-id="">
																					<p className="text-caption invisible">&amp;nbsp;
																					</p>
																					<br />
																				</div>
																			</div>
																			<div className="pt-1 flex flex-col items-stretch justify-between">
																				<div className="flex items-center justify-between">
																					{ product.discount &&
																					<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error">
																						<span className="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(product.discount)}%
																						</span>
																					</div>
																					}
																					<div className="flex items-center justify-end gap-1 text-neutral-700 text-h5 grow">
																						<span data-testid="price-final">{product.price !== null ? toPersianDigits(product.price) : 'ناموجود'}
																						</span>
																						{product.price &&
																						<div className="flex">
																							<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}}>
																								<use xlinkHref="#toman"></use>
																							</svg>
																						</div>}
																					</div>
																				</div>
																				{ product.discount &&
																				<div className="flex items-center justify-between pl-5">
																					<div data-testid="price-no-discount" className="text-neutral-300 line-through self-end mr-auto text-body-2">{toPersianDigits(product.oldPrice)}
																					</div>
																				</div>
																				}
																			</div>
																		</div>
																	</div>
																</article>
															</div>
														</Link>
					                    			</SwiperSlide>
					                    		);
					                    	})
					                    }
									</Swiper>
								</div>
							</div>
						</div>
					</div>
					}
					<div>
						<div className="w-full block sticky z-2 bg-neutral-000 styles_Tabs__XG9uc mt-5" style={ showNav ? {top: '168px'} : {top: '128px'} }>
							<div>
								<ul className="flex relative border-complete-b-200 w-full overflow-x-auto hide-scrollbar">
									<li className="relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 text-primary-500 text-subtitle-strong cursor-pointer text-body2-strong flex min-w-fit max-w-[300px] lg:max-w-[400px] overflow-hidden" data-cro-id="pdp-scroll-menu">معرفی
										<div className="absolute bottom-0 styles_Tab__border__6fH9m">
										</div>
									</li>
									<li className="relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 text-subtitle text-neutral-500 cursor-pointer text-body2-strong flex min-w-fit max-w-[300px] lg:max-w-[400px] overflow-hidden" data-cro-id="pdp-scroll-menu">مشخصات
										<div className="absolute bottom-0 opacity-0 styles_Tab__border__6fH9m">
										</div>
									</li>
									<li className="relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 text-subtitle text-neutral-500 cursor-pointer text-body2-strong flex min-w-fit max-w-[300px] lg:max-w-[400px] overflow-hidden" data-cro-id="pdp-scroll-menu">دیدگاه‌ها
										<div className="absolute bottom-0 opacity-0 styles_Tab__border__6fH9m">
										</div>
									</li>
									<li className="relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 text-subtitle text-neutral-500 cursor-pointer text-body2-strong flex min-w-fit max-w-[300px] lg:max-w-[400px] overflow-hidden" data-cro-id="pdp-scroll-menu">پرسش‌ها
										<div className="absolute bottom-0 opacity-0 styles_Tab__border__6fH9m">
										</div>
									</li>
								</ul>
							</div>
						</div>
						<div className="flex w-full">
							<div className="grow min-w-0">
								<article className="lg:mt-4 px-5 lg:px-0 pb-5 styles_PdpProductContent__sectionBorder__39zAX">
									<div id="PdpShortReview">
										<div className="break-words py-3">
											<div className="flex items-center grow">
												<h2 className="grow text-h5">
													<span className="relative">معرفی
													</span>
												</h2>
											</div>
											<div className="mt-2 styles_Title__line__KyW9l styles_Title__line--red__TP9mu">
											</div>
										</div>
									</div>
									<div className="text-body-1 text-neutral-800">{displayedDescriptionText}
									</div>
									<div className="mt-2 mb-3 pr-0 text-secondary-500 flex items-center">
										<span data-cro-id="pdp-more-detail">
											<span onClick={toggleDescriptionExpanded} className="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-button-2">
												<span>{descriptionExpanded ? 'بستن' : 'بیشتر'}
												</span>
												<div className="flex">
													<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}}>
														<use xlinkHref="#chevronLeft"></use>
													</svg>
												</div>
											</span>
										</span>
									</div>
									<div className="flex content-between w-full overflow-x-scroll lg:overflow-x-hidden mt-4">
									</div>
								</article>
								<section ref={attributeRef} style={{scrollMarginTop: '168px'}} className="lg:mt-4 px-5 lg:px-0 pb-5 styles_PdpProductContent__sectionBorder__39zAX">
									<div className="hidden lg:block">
										<div className="break-words py-3 hidden lg:block">
											<div className="flex items-center grow">
												<h2 className="grow text-h5 text-neutral-900">
													<span className="relative">مشخصات
													</span>
												</h2>
											</div>
											<div className="mt-2 styles_Title__line__KyW9l styles_Title__line--red__TP9mu">
											</div>
										</div>
									</div>
									{ !isShowAllAttributes ?
										<>
											<div className="mt-4 grow" id="specification">
												{ 
													attributesFull && attributesFull.length > 0 ?
														<div className="flex flex-col lg:flex-row pb-6 lg:py-4 styles_SpecificationBox__main__JKiKI">
															<p className="w-full lg:ml-12 text-h5 text-neutral-700 shrink-0 mb-3 lg:mb-0 styles_SpecificationBox__title__ql60s">{attributesFull[0].category}
															</p>
															<div className="w-full grow">
																{ 
																	attributesFull[0].items.map((item, itemIndex) => (
																		<div key={itemIndex} className="w-full flex last styles_SpecificationAttribute__valuesBox__gvZeQ">
																			<p className="ml-4 text-body-1 text-neutral-500 py-2 lg:py-3 lg:p-2 shrink-0 styles_SpecificationAttribute__value__CQ4Rz">{item.attribute}
																			</p>
																			<div className="border-complete-b py-2 lg:py-3 grow">
																				<p className="flex items-center w-full text-body-1 text-neutral-900 break-words">{item.value}
																				</p>
																			</div>
																		</div>
																	))
																}
																<div className="hidden">
																</div>
															</div>
														</div>
													:''
												}
											</div>
											<span onClick={showAllAttributes} class="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-button-2">
												<span>مشاهده بیشتر
												</span>
												<div class="flex">
													<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}}>
														<use xlinkHref="#chevronLeft"></use>
													</svg>
												</div>
											</span>
										</>
									:
									<>
										{ 
											attributesFull && attributesFull.map((attribute, index) => (
												<div key={index} ref={index === 0 ? specRef : null} className="flex flex-col lg:flex-row pb-6 lg:py-4 styles_SpecificationBox__main__JKiKI">
													<p className="w-full lg:ml-12 text-h5 text-neutral-700 shrink-0 mb-3 lg:mb-0 styles_SpecificationBox__title__ql60s">{attribute.category}
													</p>
													<div className="w-full grow">
														{ 
															attribute.items.map((item, itemIndex) => (
																<div key={itemIndex} className="w-full flex last styles_SpecificationAttribute__valuesBox__gvZeQ">
																	<p className="ml-4 text-body-1 text-neutral-500 py-2 lg:py-3 lg:p-2 shrink-0 styles_SpecificationAttribute__value__CQ4Rz">{item.attribute}
																	</p>
																	<div className="border-complete-b py-2 lg:py-3 grow">
																		<p className="flex items-center w-full text-body-1 text-neutral-900 break-words">{item.value}
																		</p>
																	</div>
																</div>
															))
														}
														<div className="hidden">
														</div>
													</div>
												</div>
											))
										}
										<span onClick={hideAllAttributes} class="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-button-2">
											<span>بستن
											</span>
											<div class="flex">
												<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}}>
													<use xlinkHref="#chevronLeft"></use>
												</svg>
											</div>
										</span>
									</>
									}
									
								</section>
								
								
								<div className="lazyload-wrapper " ref={commentRef}>
									<div id="commentSection">
										<section>
											<div className="hidden">
											</div>
											<div className="lg:mt-4 pb-3 w-screen !lg:w-auto styles_PdpProductContent__sectionBorder__39zAX">
												<div className="break-words py-3">
													<div className="flex items-center grow">
														<p className="grow text-h5">
															<span className="relative">امتیاز و دیدگاه کاربران
															</span>
														</p>
													</div>
													<div className="mt-2 styles_Title__line__KyW9l styles_Title__line--red__TP9mu">
													</div>
												</div>
												<div className="flex justify-start items-start mt-3">
													<div className="lg:block ml-12 left-0 sticky styles_pdpCommentQuestionSummary__HRGaN" style={ showNav ? {top: '231.031px'} : {top: '191.031px'} }>
														<div className="flex items-center">
															<p className="text-h2 ml-1 leading-none">{toPersianDigits(product.rate)}
															</p>
															<p> از ۵ 
															</p>
														</div>
														<div className="flex items-center">
															<div className="inline-flex flex-nowrap relative mt-1">
																<div className="flex">
																	<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																		<use xlinkHref="#starFill"></use>
																	</svg>
																</div>
																<div className="flex">
																	<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																		<use xlinkHref="#starFill"></use>
																	</svg>
																</div>
																<div className="flex">
																	<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																		<use xlinkHref="#starFill"></use>
																	</svg>
																</div>
																<div className="flex">
																	<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																		<use xlinkHref="#starFill"></use>
																	</svg>
																</div>
																<div className="flex">
																	<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																		<use xlinkHref="#starFill"></use>
																	</svg>
																</div>
																<div className="absolute right-0 top-0 overflow-hidden h-5" style={{width: `${parseFloat(product.rate) * 100 / 5}%`}}>
																	<div className="absolute right-0 top-0 flex flex-nowrap">
																		<div className="flex">
																			<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-warning)'}}>
																				<use xlinkHref="#starFill"></use>
																			</svg>
																		</div>
																		<div className="flex">
																			<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-warning)'}}>
																				<use xlinkHref="#starFill"></use>
																			</svg>
																		</div>
																		<div className="flex">
																			<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-warning)'}}>
																				<use xlinkHref="#starFill"></use>
																			</svg>
																		</div>
																		<div className="flex">
																			<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-warning)'}}>
																				<use xlinkHref="#starFill"></use>
																			</svg>
																		</div>
																		<div className="flex">
																			<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-warning)'}}>
																				<use xlinkHref="#starFill"></use>
																			</svg>
																		</div>
																	</div>
																</div>
															</div>
															<p className="text-neutral-400 body-2 mr-2">از مجموع {toPersianDigits(product.totalPoint)} امتیاز
															</p>
														</div>
														{/*<p className="text-neutral-700 mt-4 mb-3 text-caption">شما هم درباره این کالا دیدگاه ثبت کنید
														</p>
														<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--outlined__saFC3 styles_btn--primary__y0GEv rounded-medium w-full mt-2 text-button-2" data-cro-id="pdp-add-comment">
															<div className="flex items-center justify-center relative grow">ثبت دیدگاه
															</div>
														</button>
														<div className="rounded mt-3">
															<div className="flex">
																<div className="flex mt-1">
																	<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-neutral-hint)'}}>
																		<use xlinkHref="#infoOutline"></use>
																	</svg>
																</div>
																<span className="mr-2 text-body-2 text-neutral-500">
																</span>
																<p className="text-neutral-600 text-body-2">با ثبت دیدگاه بر روی کالاهای خریداری شده ۵ امتیاز در دیجی‌کلاب دریافت کنید
																</p>
															</div>
														</div>*/}
													</div>
													<div className="grow min-w-0">
														{/*<div>
															<div className="mt-5 border-complete-b-200">
																<div>
																	<div className="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode swiper-container-rtl">
																		<div className="swiper-wrapper">
																			<div className="swiper-slide swiper-slide-active" style={{width: 'auto', height: 'auto', marginLeft: '24px'}}>
																				<div data-cro-id="pdp-pics-in-comment" className="overflow-hidden border-complete  ml-2 my-2 rounded overflow-hidden cursor-pointer object-cover shrink-0 styles_pdpCommentSectionThumbnailItem__4WIsJ" style={{width: '57px', height: '57px', borderRadius: '8px', lineHeight: '0'}}>
																					<img className="w-full bg-neutral-000 inline-block" src="" width="57" height="57" alt="" title="" style={{objectFit: 'cover', borderRadius: '8px'}} />
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<span data-cro-id="pdp-customer-pics-down">
																	<span className="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-button-2 mb-5 mt-3">
																		<span>مشاهده همه
																		</span>
																		<div className="flex">
																			<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}}>
																				<use xlinkHref="#chevronLeft"></use>
																			</svg>
																		</div>
																	</span>
																</span>
															</div>
														</div>*/}
														<div className="flex flex-row items-center gap-x-4">
															{/*<div className="break-words py-3">
																<div className="flex items-center grow">
																	<div className="flex shrink-0 ml-2">
																		<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																			<use xlinkHref="#sort"></use>
																		</svg>
																	</div>
																	<p className="grow cursor-pointer whitespace-nowrap text-neutral-700  text-body2-strong">
																		<span className="relative">مرتب سازی:
																		</span>
																	</p>
																</div>
															</div>
															<div className="styles_HeaderSort__SortList__OPEV3">
																<span className="cursor-pointer whitespace-nowrap text-body-2 text-neutral-500" data-cro-id="pdp-comment-sort">جدیدترین
																</span>
																<span className="cursor-pointer whitespace-nowrap text-body-2 text-neutral-500" data-cro-id="pdp-comment-sort">دیدگاه خریداران
																</span>
																<span className="cursor-pointer whitespace-nowrap text-body2-strong text-primary-700" data-cro-id="pdp-comment-sort">مفیدترین
																</span>
															</div>*/}
															<div className="mr-auto block">
																<span className="text-neutral-500 whitespace-nowrap text-body-2 ellispis-1 xl:flex items-center gap-2">{toPersianDigits(productComments.length)} دیدگاه
																</span>
															</div>
														</div>
														<div>
															{
																productComments.map((comment, key) => (
																	<article key={`product-comments-${key}`} className="py-3 lg:mt-0 br-list-vertical-no-padding-200">
																		<div className="w-full flex justify-between">
																			<div className="w-full">
																				<div className="flex items-start w-full mt-1">
																					<div className="grow">
																						<div>
																							<div className="flex items-center">
																								<p className="text-caption text-neutral-400 inline">{comment.userName}
																								</p>
																								<div className="inline-flex items-center mr-2 Badge_Badge__QIekq Badge_Badge--small__ElV6O px-2 text-caption-strong" style={{backgroundColor: 'rgba(76, 175, 80, 0.1)', color: 'var(--color-hint-text-success)'}}>
																									<p className="inline-block  text-caption-strong">خریدار
																									</p>
																								</div>
																								<div className="flex my-2 mx-2">
																									<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
																										<use xlinkHref="#dotOutline"></use>
																									</svg>
																								</div>
																								<p className="text-caption text-neutral-400 inline">{toPersianDigits(comment.registerDate)}
																								</p>
																							</div>
																							<div className="inline-flex flex-nowrap relative mt-3">
																								<div className="flex">
																									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																										<use xlinkHref="#starOutline"></use>
																									</svg>
																								</div>
																								<div className="flex">
																									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																										<use xlinkHref="#starOutline"></use>
																									</svg>
																								</div>
																								<div className="flex">
																									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																										<use xlinkHref="#starOutline"></use>
																									</svg>
																								</div>
																								<div className="flex">
																									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																										<use xlinkHref="#starOutline"></use>
																									</svg>
																								</div>
																								<div className="flex">
																									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																										<use xlinkHref="#starOutline"></use>
																									</svg>
																								</div>
																								<div className="absolute right-0 top-0 overflow-hidden h-5" style={{width: `${parseFloat(comment.rate) * 100 / 5}%`}}>
																									<div className="absolute right-0 top-0 flex flex-nowrap">
																										<div className="flex">
																											<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
																												<use xlinkHref="#starFill"></use>
																											</svg>
																										</div>
																										<div className="flex">
																											<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
																												<use xlinkHref="#starFill"></use>
																											</svg>
																										</div>
																										<div className="flex">
																											<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
																												<use xlinkHref="#starFill"></use>
																											</svg>
																										</div>
																										<div className="flex">
																											<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
																												<use xlinkHref="#starFill"></use>
																											</svg>
																										</div>
																										<div className="flex">
																											<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
																												<use xlinkHref="#starFill"></use>
																											</svg>
																										</div>
																									</div>
																								</div>
																							</div>
																							<div className="flex items-center">
																							</div>
																						</div>
																						<div className="gap-y-3 flex flex-col">
																							<p className="text-body-1 text-neutral-900 mb-1 break-words">{comment.comment}
																							</p>
																							{/*<div className="flex justify-start items-center flex-wrap">
																								<div className="my-3 ml-2" style={{width: '50px', height: '50px', lineHeight: '0'}}>
																									<img className="w-full inline-block" src="" width="50" height="50" alt="" title="" style={{objectFit: 'contain'}} />
																								</div>
																							</div>*/}
																						</div>
																						<div className="w-full flex items-center flex-row mt-3">
																							<div className="flex items-center">
																								<Link to={`/seller/${comment.sellerCode}`} className="flex items-center" >
																									<div className="flex text-neutral-700 ml-2">
																										<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
																											<use xlinkHref="#seller"></use>
																										</svg>
																									</div>
																									<p className="text-caption text-neutral-700 inline">{comment.sellerTitle}
																									</p>
																								</Link>
																								<div className="flex lg:mx-2 border-100">
																									<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
																										<use xlinkHref="#dotOutline"></use>
																									</svg>
																								</div>
																								{ comment.optionTitle !== null &&
																									<>
																										{ comment.colorHex !== null ?
																											<div className="ml-2 inline-block rounded-circle styles_PdpCommentContentFooter__purchasedItem--color__GOLKc" style={{backgroundColor: `#${comment.colorHex}`}}>
																											</div>
																											:
																											<div className="flex ml-2">
																												<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
																													<use xlinkHref="#variationSize" />
																												</svg>
																											</div>
																										}
																										<p className="text-caption text-neutral-700 inline">{comment.optionTitle}
																										</p>
																									</>
																								}
																							</div>
																							{/*<div className="flex items-center text-neutral-500 pt-1 lg:justify-end mr-auto">
																								<div className="mr-auto lg:mr-0 flex items-center">
																									<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 rounded-medium px-2 px-2 text-neutral-400" data-cro-id="pdp-comment-like">
																										<div className="flex items-center justify-center relative grow">
																											<p>۲۹
																											</p>
																											<div className="flex mr-1 text-neutral-400">
																												<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																													<use xlinkHref="#thumbsUp"></use>
																												</svg>
																											</div>
																										</div>
																									</button>
																									<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 rounded-medium mr-1 px-2 text-neutral-400" data-cro-id="pdp-comment-dislike">
																										<div className="flex items-center justify-center relative grow">
																											<p>۳
																											</p>
																											<div className="flex mr-1 text-neutral-400">
																												<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																													<use xlinkHref="#thumbsDown"></use>
																												</svg>
																											</div>
																										</div>
																									</button>
																								</div>
																							</div>*/}
																						</div>
																					</div>
																				</div>
																			</div>
																			{/*<div className="mr-auto pt-1">
																				<div>
																					<button data-cro-id="pdp-comment-three-dots" type="button">
																						<div className="flex">
																							<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																								<use xlinkHref="#moreVert"></use>
																							</svg>
																						</div>
																					</button>
																				</div>
																			</div>*/}
																		</div>
																	</article>
																))
															}

															{/*<div className="border-complete-t-200 py-3">
																<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--text__W2jhM styles_btn--primary__y0GEv rounded-medium text-secondary-500" data-cro-id="pdp-comments-more">
																	<div className="flex items-center justify-center relative grow">
																		<p className="text-secondary-500">۳ دیدگاه دیگر
																		</p>
																		<div className="flex mr-1">
																			<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-secondary)'}}>
																				<use xlinkHref="#expandMore"></use>
																			</svg>
																		</div>
																	</div>
																</button>
															</div>*/}
														</div>
													</div>
												</div>
											</div>
										</section>
									</div>
								</div>
							</div>
							<div className="hidden 3xl:block mr-10 relative">
								<div className="sticky styles_MiniBuyBox__stickyAnimation__uFMh2" style={{top: '171.031px'}}>
									<div className="bg-neutral-100 mb-2 mt-5 p-4 rounded border-complete-200 text-body-2 styles_MiniBuyBox__s5_RW">
										<div className="flex items-center text-h5 py-2">
											<div className="ml-2 flex items-center justify-center" style={{width: '139px', height: '16px', lineHeight: '0'}}>
												<img className="w-full inline-block" src={IncredibleSVG} width="139" height="16" alt="" title="" style={{objectFit: 'contain'}} />
											</div>
											<div>
											</div>
											<div className="flex items-center justify-center gap-1 text-primary-700 mx-auto mt-1">
												<span className="text-body1-strong">۰۵ : ۲۶ : ۰۷
												</span>
											</div>
										</div>
										<div className="flex border-complete-b-200 pb-3 mb-3">
											<div className="rounded shrink-0 styles_MiniBuyBox__image__eDREv" style={{width: '80px', height: '80px', lineHeight: '0'}}>
												<picture>
													<source type="image/webp" srcset={ProductImgWEBP} />
													<source type="image/jpeg" srcset={ProductImgJpg} />
													<img className="w-full inline-block" src={ProductImgWEBP} width="80" height="80" alt="هندزفری بلوتوثی ایکس او مدل x23" title="" style={{objectFit: 'contain'}} />
												</picture>
											</div>
											<div className="flex flex-col mr-5">
												<p className="ellipsis-2">{product.title}
												</p>
												<div className="flex items-center mt-auto">
													<div className="rounded-circle styles_MiniBuyBox__color__4Im3p" style={{background: 'rgb(255, 222, 173)'}}>
													</div>
													<p className="mr-2">کرم روشن
													</p>
												</div>
											</div>
										</div>
										<div className="flex mb-2">
											<div className="ml-2 flex items-center justify-center">
												<div className="relative">
													<div className="flex">
														<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#seller"></use>
														</svg>
													</div>
												</div>
											</div>
											<div className="text-neutral-700 text-body-2">بازرگانی ایتالیا 
											</div>
										</div>
										<div className="flex mb-2">
											<div className="ml-2 flex items-center justify-center">
												<div className="flex">
													<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
														<use xlinkHref="#guarantee"></use>
													</svg>
												</div>
											</div>
											<div className="text-neutral-700 text-body-2">گارانتی اصالت و سلامت فیزیکی کالا 
											</div>
										</div>
										<div className="flex mb-2">
											<div className="ml-2 flex items-center justify-center">
												<div className="flex">
													<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
														<use xlinkHref="#productIdeal"></use>
													</svg>
												</div>
											</div>
											<div className="text-neutral-700 text-body-2">موجود در انبار فروشنده 
											</div>
										</div>
										<div className="relative w-full mt-1">
											<div className="w-full  z-3 bg-neutral-000 shadow-fab-button lg:shadow-none styles_BuyBoxFooter__actionWrapper__Hl4e7">
												<div>
													<div className="flex items-center">
														<div className="flex justify-start flex-col items-end mr-auto text-h3">
															<div className="flex items-center justify-end w-full gap-1">
																<span className="line-through text-body-2 ml-1 text-neutral-300" data-testid="price-no-discount">۲,۰۰۰,۰۰۰
																</span>
																<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error shrink-0 mr-1 mb-1">
																	<span className="text-body2-strong" data-testid="price-discount-percent">۸۰٪
																	</span>
																</div>
															</div>
															<div className="flex flex-row items-center">
																<span className="ml-1 text-neutral-800 text-h4-compact" data-testid="price-final">۳۹۹,۰۰۰
																</span>
																<div className="flex">
																	<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
																		<use xlinkHref="#toman"></use>
																	</svg>
																</div>
															</div>
														</div>
													</div>
													<div>
														<div className="overflow-hidden h-5 mb-3">
															<div style={{transform: 'translateY(0px)', transitionDuration: '0s'}}>
																<div className="flex items-center h-5 overflow-hidden whitespace-nowrap">
																	<div className="flex ml-1">
																		<div style={{width: '18px', height: '18px', lineHeight: '0'}}>
																			<img className="w-full" src={IncredibleEmoji} width="18" height="18" style={{objectFit: 'cover'}} />
																		</div>
																	</div>
																	<p className="text-body2-strong" style={{color: 'rgb(16, 126, 24)'}}>بهترین قیمت در ۳۰ روز گذشته
																	</p>
																</div>
																<div className="flex items-center h-5 overflow-hidden whitespace-nowrap">
																	<div className="flex ml-1">
																		<div style={{width: '18px', height: '18px', lineHeight: '0'}}>
																			<span className="w-full" style={{display: 'inline-block', objectFit: 'cover', width: '18px', height: '18px'}}>
																			</span>
																		</div>
																	</div>
																	<p className="text-body2-strong" style={{color: 'rgb(0, 126, 148)'}}>در سبد خرید ۱۰۰+ نفر
																	</p>
																</div>
																<div className="flex items-center h-5 overflow-hidden whitespace-nowrap">
																	<div className="flex ml-1">
																		<div style={{width: '18px', height: '18px', lineHeight: '0'}}>
																			<span className="w-full" style={{display: 'inline-block', objectFit: 'cover', width: '18px', height: '18px'}}>
																			</span>
																		</div>
																	</div>
																	<p className="text-body2-strong" style={{color: 'rgb(0, 126, 148)'}}>۱۰۰۰+ بازدید در ۲۴ ساعت اخیر
																	</p>
																</div>
																<div className="flex items-center h-5 overflow-hidden whitespace-nowrap">
																	<div className="flex ml-1">
																		<div style={{width: '18px', height: '18px', lineHeight: '0'}}>
																			<span className="w-full" style={{display: 'inline-block', objectFit: 'cover', width: '18px', height: '18px'}}>
																			</span>
																		</div>
																	</div>
																	<p className="text-body2-strong" style={{color: 'rgb(16, 126, 24)'}}>بهترین قیمت در ۳۰ روز گذشته
																	</p>
																</div>
															</div>
														</div>
													</div>
													<div className="flex items-center">
														<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--primary__y0GEv rounded-medium w-full" data-cro-id="pdp-mini-add-to-cart" data-add-to-cart-variant-id="64672704" data-testid="add-to-cart">
															<div className="flex items-center justify-center relative grow">افزودن به سبد
															</div>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div id="tabularRecommendation">

					</div>
				</div>
				<div className="z-2 flex flex-col hide-scrollbar styles_Layout__jJdiO hidden">
					<div className="grow bg-neutral-000 lg:rounded-large flex flex-col overflow-hidden styles_Layout__content__nlhKE">
						<header className="w-full bg-primary-500 text-white px-5 py-2">
							<div className="flex items-center justify-between">
								<h2 className="text-h4">پشتیبانی آنلاین
								</h2>
								<div className="flex cursor-pointer">
									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
										<use xlinkHref="#arrowLeft"></use>
									</svg>
								</div>
							</div>
						</header>
						<div className="">
						</div>
					</div>
				</div>
			</div>
		</div>

    );
}

export default Product;